import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { FontIcon } from 'react-toolbox';
import { urls } from 'helpers/url';
import DocumentLink from 'components/DocumentsTable/documentLink';
import { EditableTableRow, EditableTableCell } from 'components/EditableTable';
import S from '../jobHistoryStyles.scss';

const JobHistoryRow = ({ appt }) => {
  const hasPhase = !!(appt.phase || null) && appt.phase !== 'N/A';

  const renderCrewCell = () => (<EditableTableCell
    label="Crew"
    value={appt.crew}
    cellReadOnly
  />);

  const renderLink = () => (hasPhase ? (<Link
    to={urls.phaseHistory(appt.phase)}
    target="_blank"
  >{appt.phase.project_number}</Link>) : 'N/A');

  const renderProjectNumberCell = () => {
    const link = renderLink();
    return (<EditableTableCell
      label="Project Number"
      value={link}
      cellReadOnly
    >{link}</EditableTableCell>);
  };

  const renderApptTypeCell = () => (<EditableTableCell
    label="Appt. Type"
    value={appt.apptType}
    cellReadOnly
  />);

  const renderDateCell = (label, date) => (<EditableTableCell
    label={`${label} Date`}
    value={date}
    cellReadOnly
  />);

  const renderDocLink = url => (url ? (<DocumentLink href={url}>
    <FontIcon className={S.downloadIcon} value="launch" />
  </DocumentLink>) : 'N/A');

  const renderInspectionCell = () => {
    let link = 'N/A';
    if (hasPhase) {
      const { phase, crewId } = appt;
      const doc = (phase.document_uploads || []).length ?
        (phase.document_uploads.find(d =>
          d.document_name.includes(`ID: ${crewId}`)) || null) : null;
      const url = doc ? doc.expiring_download_url : doc;
      link = renderDocLink(url);
    }
    return (<EditableTableCell
      label="Crew Inspection"
      value={link}
      cellReadOnly
    >{link}</EditableTableCell>);
  };

  return (<EditableTableRow readOnly>
    {renderCrewCell()}
    {renderProjectNumberCell()}
    {renderApptTypeCell()}
    {renderDateCell('Start', appt.startDate)}
    {renderDateCell('End', appt.endDate)}
    {renderInspectionCell()}
  </EditableTableRow>);
};

JobHistoryRow.propTypes = {
  appt: PropTypes.object, className: PropTypes.string,
};

JobHistoryRow.defaultProps = { appt: null, className: '' };

export default JobHistoryRow;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/reports/jobHistory/components/JobHistoryRow.jsx